<template>
    <Header></Header>
    <Left></Left>
    <section class="container">
        <div class="blue_box _full">
            <div class="box_tit _flex">
                <h2>자료집</h2>
                <div class="info_box">
                    <div>
                        총 게시글
                        <span class="col_blue">{{ CommonUtils.numberFormat(state.totalLength) }}개</span>
                    </div>
                </div>
            </div>
            <div class="sch_condition_wrap">
                <div class="left">
                    <div class="select_date_wrap">
                        <div class="select_date">
                            <input type="date" @keydown.enter="searchDate" name="" id="" v-model="form_state.startDate" @change="getList" />
                        </div>
                        <div class="select_date">
                            <input
                                style="margin-left: 5px"
                                type="date"
                                @keydown.enter="searchDate"
                                name=""
                                id=""
                                v-model="form_state.endDate"
                                @change="getList"
                            />
                        </div>
                    </div>
                    <div class="search_wrap">
                        <input
                            type="text"
                            v-model="state.searchText"
                            @keyup.enter="
                                state.page = 1;
                                getList();
                            "
                            placeholder="제목을 입력하세요."
                        />
                        <button
                            type="button"
                            class="search_btn icon_wrap"
                            @click="
                                state.page = 1;
                                getList();
                            "
                        >
                            <img src="img/search_btn.png" alt="" />
                        </button>
                    </div>
                </div>
                <div class="right">
                    <button type="button" class="default_btn _blue" @click="addNews">등록</button>
                    <button type="button" class="default_btn _gray" @click="isDelete">삭제</button>
                </div>
            </div>

            <div class="common_table custom_scroll">
                <table>
                    <colgroup>
                        <col style="width: 40px" />
                        <col style="width: 100px" />
                        <col />
                        <col style="width: 180px" />
                        <col style="width: 80px" />
                        <col style="width: 80px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th class="checkbox_wrap cnt p_5 checkbox_wrap2">
                                <input type="checkbox" v-model="state.checkAll" @change="toggleAll()" />
                            </th>
                            <th>번호</th>
                            <th>제목</th>
                            <th>작성일</th>
                            <th>수정</th>
                            <th>다운로드</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-if="state.list.length > 0">
                            <tr v-for="(item, idx) in state.list" :key="item.idx">
                                <td class="checkbox_wrap cnt p_5 checkbox_wrap2">
                                    <label :for="'chk_' + item.idx" @click.stop>
                                        <input type="checkbox" :id="'chk_' + item.idx" v-model="state.checkedList" :value="item.idx" @click.stop />
                                    </label>
                                </td>
                                <td class="list_num">{{ (state.page - 1) * state.size + (idx + 1) }}</td>
                                <td class="ellipsis_1">
                                    <button type="button" class="tb_img img_wrap" @click="viewImage(item.thumbnail)" v-if="item.thumbnail">
                                        <img :src="item.thumbnail ? item.thumbnail : 'img/login_bg.png'" alt="" />
                                    </button>
                                    <span class="underline">
                                        <a :href="state.userSiteUrl + '/#/archiveView/' + +item.idx" target="_blank">{{ item.title }}</a>
                                    </span>
                                </td>
                                <td class="cnt">{{ CommonUtils.dateFormat(new Date(item.createDate), ".", true) }}</td>
                                <td class="cnt p_5">
                                    <button type="button" class="table_btn _blue" @click="isShowModifyModal(item.idx)">수정</button>
                                </td>
                                <td class="cnt p_5">
                                    <img class="download_img" src="@/assets/download.png" alt="" @click="downloadFiles(item.fileList)" />
                                </td>
                            </tr>
                        </template>
                        <tr v-else>
                            <td colspan="6">
                                <div class="tb_subject" style="text-align: center; width: 100%">등록된 게시물이 없습니다.</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <PageBtn
                v-if="state.list.length !== 0"
                :currentPage="state.page"
                :totalLength="state.totalLength"
                :perPage="state.size"
                :data="state.data"
                @onPaging="handlePageChange"
            ></PageBtn>
        </div>
    </section>

    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>

    <ArchiveModal
        v-if="state.isNewsShowModal"
        :data="state.newsInfo"
        @callback="
            state.isNewsShowModal = false;
            getList();
        "
        @close="state.isNewsShowModal = false"
    ></ArchiveModal>
</template>
<script lang="ts" config>
    import {
        userStore,
        globalStore,
        popupStore,
        reactive,
        watch,
        apiService,
        onMounted,
        router,
        Header,
        Left,
        PageBtn,
        ModalDefault,
        types,
        ref,
        onBeforeUnmount,
        getMessageByCode,
        CommonUtils,
        ArchiveModal,
        onBeforeMount,
    } from "@/BaseComponent";

    export default {
        props: {},
        components: { Header, Left, ModalDefault, PageBtn, ArchiveModal },
        setup() {
            const global = globalStore();
            const user = userStore();
            const popup = popupStore();

            const state = reactive({
                hasAuth: false as boolean,
                list: [] as Array<any>,
                data: {},
                memberInfo: {},
                newsInfo: {} as any,

                page: 1 as number,
                size: 20 as number,
                totalPage: 1 as number,
                totalLength: 0 as number,

                checkAll: false as boolean,
                checkedList: [] as Array<number>,

                searchType: "" as string,
                searchText: "" as string,
                startDate: "" as string,
                endDate: "" as string,
                title: "" as string,

                isShowSearchType: false,
                isNewsShowModal: false as boolean,

                state: "99" as string,
                detailTxt: "전체" as string,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                type: 4 as any, // board > 감시소식 타입
                userSiteUrl: process.env.VUE_APP_USER_FRONT_ADDRESS,
            });

            const form_state = reactive({
                startDate: "" as string,
                endDate: "" as string,
            });

            const imgError = (e: Event) => {
                const target = e.target as HTMLImageElement;
                if (target) {
                    target.src = require("@/assets/no_img.png");
                }
            };

            onMounted(() => {
                // global.$reset();
                getList();
            });

            onBeforeUnmount(() => {});

            watch(
                () => [state.checkedList, state.list],
                () => {
                    state.checkAll = state.checkedList.length > 0 && state.checkedList.length === state.list.length;
                },
            );

            watch(
                () => state.searchText,
                (newVal, oldVal) => {
                    if (oldVal && newVal === "") {
                        getList();
                    }
                },
            );

            const handlePageChange = (page: number) => {
                state.page = page;
                getList();
            };

            const closeModal = () => {
                state.isShowModal = false;
            };

            const callBackModal = async (param: any) => {
                if (param.action === "confirm") {
                    deleteCheckList();
                }
            };

            // const search_type_list = [
            //     { id: "all", key: "99", value: "전체" },
            //     { id: "1", key: "1", value: "완료" },
            //     { id: "2", key: "0", value: "대기중" },
            // ];

            const toggleAll = () => {
                if (state.checkAll) {
                    state.checkedList = state.list.map((item) => item.idx);
                } else {
                    state.checkedList = [];
                }
            };

            const searchDate = async () => {
                if (form_state.startDate && form_state.endDate && form_state.endDate < form_state.startDate) {
                    form_state.endDate = "";
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "날짜를 올바르게 선택해주세요.";
                    state.isShowModal = true;
                    return;
                }

                state.startDate = form_state.startDate;
                state.endDate = form_state.endDate;
                state.page = 1;
                getList();
            };

            const getList = async () => {
                state.checkedList = [];
                const param: types.ReqArchivesListForAdmin = {
                    page: state.page,
                    size: state.size,
                    searchType: state.searchType,
                    searchText: state.searchText,
                    startDate: state.startDate,
                    endDate: state.endDate,
                };

                const res = await apiService.archives.list(param);

                if (res.returnCode === 0) {
                    state.list = res.list.data;
                    state.totalLength = res.list.recordsTotal;
                } else {
                    state.list = [];
                    state.totalPage = 0;
                    state.totalLength = 0;
                }
            };

            const isDelete = () => {
                if (state.checkedList && state.checkedList.length > 0) {
                    state.modalTab = 5;
                    state.modalTitle = "알림";
                    state.modalContent = "정말 삭제하시겠습니까?";
                    state.isShowModal = true;
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "선택된 게시글이 없습니다.";
                    state.isShowModal = true;
                }
            };

            const deleteCheckList = async () => {
                if (state.checkedList && state.checkedList.length > 0) {
                    const param: types.ReqIdxList = {
                        idxList: state.checkedList.join(","),
                    };
                    const res = await apiService.archives.removeForList(param);

                    if (res.returnCode === 0) {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = "삭제가 완료되었습니다.";
                        state.isShowModal = true;

                        getList();
                        state.checkedList = [];
                    } else if (res.returnCode === 11) {
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "예외 발생";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "선택된 게시글이 없습니다.";
                    state.isShowModal = true;
                }
            };

            const isShowModifyModal = async (idx: number) => {
                if (idx != null && idx > 0 && idx != undefined) {
                    const res = await apiService.archives.detail(idx);
                    if (res.returnCode === 0) {
                        state.newsInfo = res.data;
                        state.isNewsShowModal = true;
                    } else {
                        state.modalTab = 8;
                        state.modalTitle = "예외 발생";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "안내";
                    state.modalContent = "문제 발생";
                    state.isShowModal = true;
                }
            };

            const viewImage = async (param: string) => {
                state.modalTab = 11;
                state.modalTitle = "알림";
                state.modalContent = param;
                state.isShowModal = true;
            };

            const addNews = () => {
                state.newsInfo = null;
                state.isNewsShowModal = true;
            };

            const downloadFiles = async (fileList: types.ResArchiveFileVOForApi[]) => {
                fileList.forEach(async (item) => {
                    const res = await fetch(item.file);
                    const blob = await res.blob();
                    const link = document.createElement("a");
                    link.href = URL.createObjectURL(blob);
                    link.download = item.fileRealName;
                    link.click();
                    URL.revokeObjectURL(link.href);
                });
            };

            return {
                state,
                user,
                router,
                closeModal,
                callBackModal,
                imgError,
                types,
                global,
                popup,
                CommonUtils,
                handlePageChange,
                toggleAll,
                form_state,
                searchDate,

                getList,
                isDelete,
                isShowModifyModal,
                viewImage,
                addNews,
                downloadFiles,
            };
        },
    };
</script>
<style scoped>
    .checkbox_wrap2 input[type="checkbox"] {
        appearance: auto;
        -webkit-appearance: auto;
        -moz-appearance: auto;
        display: inline-block;
        width: 22px;
        height: 22px;
        background-color: #fff;
        position: relative;
        vertical-align: sub;
        cursor: pointer;
        border: 1px solid #6d6d6d;
    }

    .checkbox_wrap2 em {
        display: none;
    }

    .underline {
        text-decoration: underline;
        text-underline-offset: 5px;
    }
    .download_img {
        cursor: pointer;
    }
</style>
